import { render, staticRenderFns } from "./purchase-card.vue?vue&type=template&id=afd6c0f4&scoped=true"
import script from "./purchase-card.vue?vue&type=script&lang=js"
export * from "./purchase-card.vue?vue&type=script&lang=js"
import style0 from "./purchase-card.vue?vue&type=style&index=0&id=afd6c0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd6c0f4",
  null
  
)

export default component.exports